import PropTypes from 'prop-types';

export default function OutlineChevronLeft(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m12.5 15-5-5 5-5"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineChevronLeft.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
